import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const createCheckoutExperience = {
  name: "createCheckoutExperience" as const,
  input: z.object({ name: z.string() }),
  output: z.object({ checkoutExperienceId: zExt.objectId() }),
};
